module.exports = window.L = require('leaflet/dist/leaflet-src');



//////////////////
// WEBPACK FOOTER
// ./node_modules/mapbox.js/src/leaflet.js
// module id = 390
// module chunks = 1